import { resources } from '@/mocks/resources';

interface ResourceCardProps {
  resource: typeof resources[0];
  className?: string;
}

export default function ResourceCard({ resource, className = '' }: ResourceCardProps) {
  return (
    <Link
      to={`/article/${resource.id}`}
      className={`group block bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden cursor-pointer ${className}`}
      data-product-shop=""
    >
      <div className="relative overflow-hidden aspect-[16/10]">
        <img
          src={resource.image}
          alt={resource.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={resource.title}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        {resource.hot && (
          <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
            热门
          </span>
        )}
        <div className="absolute top-3 right-3 px-2 py-0.5 bg-background-50/90 text-foreground-700 text-xs rounded-md whitespace-nowrap">
          {resource.categoryName}
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
          {resource.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {resource.description}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {resource.views >= 10000 ? `${(resource.views / 10000).toFixed(1)}万` : resource.views.toLocaleString()}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-download-line"></i>
              {resource.downloads >= 10000 ? `${(resource.downloads / 10000).toFixed(1)}万` : resource.downloads.toLocaleString()}
            </span>
          </div>
          <span className="text-xs text-foreground-400">
            {resource.fileSize}
          </span>
        </div>
      </div>
    </Link>
  );
}